/**
 * White-label surface for licensable frontend builds.
 * Licensees override via env and static assets — backend stays on Grail.
 */
export type BrandFeatureFlags = {
  observatory: boolean;
  scriptLab: boolean;
  copyTrading: boolean;
  strategyBuilder: boolean;
  mcpAgent: boolean;
};

export type BrandConfig = {
  name: string;
  shortName: string;
  logoPath: string;
  faviconPath: string;
  themeId: 'jester' | 'sceptre' | string;
  apiBaseUrl: string;
  /** Optional split login origin. Empty = same origin. Never Castellan. */
  authBaseUrl: string;
  telegramBotUsername: string;
  docsUrl: string;
  siteUrl: string;
  termsUrl: string;
  supportUrl: string;
  privacyUrl: string;
  statusUrl: string;
  features: BrandFeatureFlags;
};

const apiBase = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim() || '';
/** Empty unless `VITE_AUTH_ORIGIN` is set. Login is this app; Castellan is a different service. */
const authBase = String(import.meta.env.VITE_AUTH_ORIGIN ?? '')
  .trim()
  .replace(/\/$/, '');
const siteUrl = (import.meta.env.VITE_JESTER_WWW_URL as string | undefined)?.trim() || 'https://www.jester.trade';

export const brand: BrandConfig = {
  name: import.meta.env.VITE_BRAND_NAME?.trim() || 'Jester',
  shortName: import.meta.env.VITE_BRAND_SHORT_NAME?.trim() || 'Jester',
  logoPath: import.meta.env.VITE_BRAND_LOGO?.trim() || '/terminal/assets/jester_logo.svg',
  faviconPath: import.meta.env.VITE_BRAND_FAVICON?.trim() || '/terminal/assets/jester_logo.svg',
  themeId: (import.meta.env.VITE_BRAND_THEME?.trim() || 'jester') as BrandConfig['themeId'],
  apiBaseUrl: apiBase,
  authBaseUrl: authBase,
  telegramBotUsername: import.meta.env.VITE_TELEGRAM_BOT_USERNAME?.trim() || 'TradewithJesterBot',
  docsUrl: import.meta.env.VITE_DOCS_URL?.trim() || `${siteUrl}/docs`,
  siteUrl,
  termsUrl: import.meta.env.VITE_TERMS_URL?.trim() || `${siteUrl}/terms-and-conditions`,
  supportUrl: `${siteUrl}/support`,
  privacyUrl: `${siteUrl}/privacy`,
  statusUrl: `${siteUrl}/status`,
  features: {
    observatory: import.meta.env.VITE_FEATURE_OBSERVATORY !== '0',
    scriptLab: import.meta.env.VITE_FEATURE_SCRIPT_LAB !== '0',
    copyTrading: import.meta.env.VITE_FEATURE_COPY_TRADING !== '0',
    strategyBuilder: import.meta.env.VITE_FEATURE_STRATEGY_BUILDER !== '0',
    mcpAgent: import.meta.env.VITE_FEATURE_MCP_AGENT !== '0',
  },
};

export default brand;
